<template>
  <v-card>
    <HTTPresponse :alert="httpalert" @changeHTTPBoxState="HTTPState"></HTTPresponse>
    <v-row wrap>
      <v-col cols="12" md="8" lg="6" offset-md="2" offset-lg="3">
        <div class="box mb-5">
          <v-layout
            d-block
            d-md-flex
            row
            ma-0
            align-center
            justify-space-between
            class="box-header"
          >
            <v-flex xs12>
              <h2 class="box-header-item mb-3 mb-md-0">{{ $t('login-screen.title') }}</h2>
            </v-flex>
          </v-layout>
          
          <div class="box-content">
            <v-form
              v-model="valid"
              @submit.prevent="login"
            >
              <v-container>

                <v-alert
                  v-model="alert"
                  :type="alertType"
                >
                  {{ alertMessage }}
                </v-alert>

                <!-- login -->
                <v-flex xs12 class="mb-4">
                  <v-text-field
                    v-model="loginName"
                    :rules="[rules.empty]"
                    :label="$t('login-screen.label-1')"
                    required
                    aria-required
                    class="mandatory"
                    outlined
                  ></v-text-field>
                </v-flex><!-- login -->

                <!-- password -->
                <v-flex xs12 class="mb-4">
                  <v-text-field
                    v-model="password"
                    :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                    :rules="[rules.lower, rules.upper, rules.number, rules.digit, rules.min(password, 7)]"
                    :type="showPassword ? 'text' : 'password'"
                    name="inputPassword"
                    :label="$t('login-screen.label-2')"
                    :hint="$t('login-screen.hint-2')"
                    counter
                    required
                    aria-required
                    class="mandatory"
                    outlined
                    @click:append="showPassword = !showPassword"
                  ></v-text-field>
                </v-flex><!-- password -->

                <!-- submit -->
                <div class="text-center">
                  <v-btn
                    :elevation="0"
                    rounded
                    color="primary"
                    class="mb-3"
                    type="submit"
                    :disabled="loginName && password &&
                               (/^\s+$/.test(loginName) === false) &&
                               /[a-z]/.test(password) && /[A-Z]/.test(password) && /[0-9]/.test(password) &&
                               /[\W_]+/.test(password) && password.length >= 7 ? false : true"
                    v-html="$t('login-screen.cta-1')"
                  ></v-btn>
                  <span class="px-3"></span>
                  <v-btn
                    :elevation="0"
                    rounded
                    outlined
                    color="primary"
                    class="fetch mb-3"
                    to="/signup"
                    v-html="$t('login-screen.cta-2')"
                  >
                  </v-btn>
                </div>

              </v-container>
            </v-form>
          </div><!-- box-content -->
        </div><!-- box -->

        <div class="text-center">
          <router-link to="/lostpassword">{{ $t('login-screen.link-1') }}</router-link>

          <!-- <span class="px-3"></span>
          <router-link to="/help" class="link disabled">{{ $t('login-screen.link-2') }}</router-link> -->

          <!-- <router-link to="/thankyou" class="link">optin</router-link> -->
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { userVar } from '@/js/auth/userVar'
import HTTPresponse from '@/components/app/HTTPresponse'

export default {
  components: {
    HTTPresponse: HTTPresponse
  },
  data () {
    return {
      alert: false,
      alertType: 'error',
      alertMessage: this.$t('basic-message.error-message'),

      // form model
      valid: false,
      rules: {
        // required: value => !!value || 'Required.',
        empty: value => {
          if (value === '') return true
          const reg = /^\s+$/
          if (reg.test(value) === true) return this.$t('rules-field.empty')
          else return true
        },
        digit: value => {
          // const reg = /\d/ // should contain at least one digit
          if (value === '') return true
          const reg = /[\W_]+/ // should contain at least one digit
          return reg.test(value) || this.$t('rules-field.digit')
        },
        number: value => {
          if (value === '') return true
          const reg = /[0-9]/ // should contain at least one number
          return reg.test(value) || this.$t('rules-field.number')
        },
        lower: value => {
          if (value === '') return true
          const reg = /[a-z]/ // should contain at least one lower case
          return reg.test(value) || this.$t('rules-field.lower')
        },
        upper: value => {
          if (value === '') return true
          const reg = /[A-Z]/ // should contain at least one upper case
          return reg.test(value) || this.$t('rules-field.upper')
        },
        min: (value, min) => {
          if (value === '') return true
          else if (value.length >= 7) return true
          else return this.$t('rules-field.min', 1, {n: min})
        }
      },

      // text-field: key
      loginName: '',

      // text-field: password
      showPassword: false,
      password: '',

      httpalert: false
    }
  },
  methods: {
    login () {
      const { loginName, password } = this
      const params = { // escape uri params
        loginName: encodeURIComponent(loginName),
        password: encodeURIComponent(password)
      }
      const uri = `?options=json&login=${params.loginName}&password=${params.password}`

      this.$store.dispatch('auth/authRequest', uri)
        .then(response => {
          this.alert = response.alert
          this.alertType = response.alertType
          this.alertMessage = response.alertMessage
          
          if (response.status === 'ok') {
            // if (!this.$store.getters['auth/isAuthenticated']) this.$store.dispatch('auth/authLogout')
            // When status connection is ok

            // call API to check first_connection var
            const params = {
              options: 'get',
              name: 'first_connection',
              key: this.$store.state.auth.token
            }
            userVar(params) // check first_connection 
              .then(response => {

                if (!this.$store.getters['auth/isAuthenticated']) this.$store.dispatch('auth/authLogout')
                // if first_connection is empty
                if (response.data === '') {
                  const params = {
                    options: 'set',
                    name: 'first_connection',
                    value: 'false',
                    key: this.$store.state.auth.token
                  }
                  userVar(params) // set first_connection to false
                    .then(response => {
                      if (response.data === 'OK' || response.data === 'ok') {
                        this.$router.push('/welcome')
                      } else { this.$store.dispatch('auth/authLogout') }
                    })
                    .catch(() => {
                      this.httpalert = true
                      setTimeout(() => {
                        this.httpalert = false
                      }, 4000)
                      this.$store.dispatch('auth/authLogout')
                    })
                } else if (response.data === false ||
                           response.data === 'false') {
                  // else if first_connection it's false
                  this.$router.push('/dashboard') // GoTo Dashboard

                } else if (response.data === true ||
                           response.data === 'true') {
                  // else if first_connection it's true
                  const params = {
                    options: 'set',
                    name: 'first_connection',
                    value: 'false',
                    key: this.$store.state.auth.token
                  }
                  userVar(params) // set first_connection to false
                    .then(response => {
                      if (response.data === 'OK' || response.data === 'ok') this.$router.push('/welcome')
                      else { this.$store.dispatch('auth/authLogout') }
                    })
                    .catch(() => {
                      this.httpalert = true
                      setTimeout(() => {
                        this.httpalert = false
                      }, 4000)
                      this.$store.dispatch('auth/authLogout')
                    })
                } // else (normaly impossible case logout...)
                else { this.$store.dispatch('auth/authLogout') }
              })
              .catch(() => {
                this.httpalert = true
                setTimeout(() => {
                  this.httpalert = false
                }, 4000)
                this.$store.dispatch('auth/authLogout')
              })
          // Else logout
          } else { this.$store.dispatch('auth/authLogout') }
        })
        .catch(error => {
          this.alert = error.alert
          this.alertType = error.alertType
          this.alertMessage = error.alertMessage
          this.$store.dispatch('auth/authLogout')
        })
    },

    HTTPState (value) {
      this.httpalert = this.value
    }
  }
}
/* eslint-disable */
</script>

<style scoped>
.v-card {
  min-height: 300px;
  margin-bottom: 30px;
}

</style>
